import { useCallback } from 'react'
import { FormikErrors } from 'formik'
import type { ActivityType } from '../../../typings'
import { useActivityTypesContext } from '../../../context'
import type { ActivityTypeFields } from '../typings'
import { trimString } from '@sales-center/common'

export function useValidation() {
  const [{ activityTypes }] = useActivityTypesContext()

  const validate = useCallback(
    (model: ActivityType) => {
      const { name, description, id } = model
      const errors: FormikErrors<ActivityTypeFields> = {}

      if (!name) {
        errors.name = 'Required'
      } else if (name.length > 30) {
        errors.name = 'Max length 30 characters'
      } else if (
        activityTypes.find(
          (activity) =>
            activity.name?.toLowerCase() === trimString(name?.toLowerCase()) &&
            activity.id != id,
        )
      ) {
        errors.name = 'Should be unique'
      }

      if (description && description.length > 150) {
        errors.description = 'Max length 150 characters'
      }

      return errors
    },
    [activityTypes],
  )

  return {
    validate,
  }
}
